import { inject, Injectable } from "@angular/core";
import type { Translation } from "@jsverse/transloco";
import { TranslocoService } from "@jsverse/transloco";
import type { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class TranslocoPreloaderService {
    private readonly translocoService = inject(TranslocoService);

    public preload(): Observable<Translation> {
        const browserLanguage = this.getBrowserLanguage();
        const activeLanguage = this.getActiveSupportedLanguage(browserLanguage);
        this.translocoService.setActiveLang(activeLanguage);
        return this.translocoService.load(activeLanguage);
    }

    private getActiveSupportedLanguage(activeLanguage: string): string {
        const isSupportedLanguage = this.translocoService.isLang(activeLanguage);
        if (isSupportedLanguage) {
            return activeLanguage;
        }

        return this.translocoService.getDefaultLang();
    }

    private getBrowserLanguage(): string {
        const browserLang = navigator.language || navigator.languages?.[0] || "";
        return browserLang.split("-")[0]?.toLowerCase();
    }
}
